
export enum HoverTarget {
	GloopButton
}
